<template>
    <div class="vconsole17-tab-center" :class="{'form-fullheight': component['form_fullheight']}">
        <div class="vconsole17-tab-center-panel" :style="{ 'min-width': panel_with }">
            <VuePlaceholder :component="component.panel" :handler="handler" />
        </div>
    </div>
</template>
<script>
export default {
    props: ['component', 'handler'],
    computed: {
        panel_with() {
            return this.component?.panel_size || 'fit-content'
        }
    }
}
</script>
<style lang="scss">

.vconsole17-tab-center-panel > .vueplaceholder > * {
    height: 100%;
}

.vconsole17-tab-center {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    width: 100%;
    height: 100%;


    padding: 32px;

    &-panel {
        max-width: 100%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: stretch;

        >* {
            height: 100%;

            .vform17-component-container {
                height: 100%;
            }
        }

    }

    &.form-fullheight {

        .f-form,
        .vform17-component-container {
            height: 100%;
        }
    }


}</style>